import React, { useContext, useEffect } from 'react';
import BookerContext from '../../context/bookerContext';
import { ReactComponent as ApplePayIcon } from '../../assets/img/apple-pay-icon.svg';
import { ReactComponent as CardIcon } from '../../assets/img/card-number-icon.svg';
import { ReactComponent as PayPalIcon } from '../../assets/img/paypal-icon.svg';
import FieldControl from '../InputControls/FieldControl';

const PaymentMethods = () => {
  const context = useContext(BookerContext);
  const { state, updatePaymentListId, updatePayment, updateOneTimePaymentId } = context;
  const { paymentListId, isWebBooker, applePayPaymentMethod, payPalPaymentMethod, editor, oneTimePaymentId } = state;

  const paymentWebList = [
    {
      id: 'applePay',
      icon: <ApplePayIcon />,
      label: '',
      visible:
        window.ApplePaySession &&
        !applePayPaymentMethod &&
        (editor?.isOpenedFromMenu ? paymentListId !== 'applePay' : true),
    },
    {
      id: 'card',
      icon: <CardIcon />,
      label: 'Credit Card',
      visible: false,
    },
    {
      id: 'payPal',
      icon: <PayPalIcon />,
      label: '',
      visible: !payPalPaymentMethod && (editor?.isOpenedFromMenu ? paymentListId !== 'payPal' : true),
    },
  ];

  const isListVisible = paymentWebList.find(p => p.visible);

  useEffect(() => {
    const paymentVisibled = paymentWebList.find(p => p.visible);
    if (editor?.isOpenedFromMenu) {
      updateOneTimePaymentId(paymentVisibled?.id);
    } else updatePaymentListId(paymentListId || paymentVisibled?.id || 'card');
  }, []);

  const onChangePaymentHandler = e => {
    const {
      target: { id },
    } = e;
    if (editor?.isOpenedFromMenu) updateOneTimePaymentId(id);
    else {
      updatePaymentListId(id);
      if (id === 'applePay' || id === 'payPal')
        updatePayment({ description: id === 'applePay' ? 'Apple Pay' : 'PayPal' });
      else updatePayment('');
    }
  };

  return (
    <>
      <div className="form-group-container">
        <div className="title">Add Payment Method</div>
        <div className="sub-title">To add a credit card to your account, please use the Curb app.</div>

        <ul className={`clearfix payment-list ${isListVisible ? 'borderBottom' : ''}`}>
          {paymentWebList.map(item => (
            <li key={item.id} className={`payment-list-item ${item.visible ? '' : 'hidden'}`}>
              <span className="payment-icon">
                {item.icon} {item.label}
              </span>
              <input
                type="radio"
                id={item.id}
                name="payment-list"
                checked={editor?.isOpenedFromMenu ? oneTimePaymentId === item.id : paymentListId === item.id}
                onChange={onChangePaymentHandler}
                className="payment-input"
              />
            </li>
          ))}
        </ul>
      </div>

      {!isWebBooker && <FieldControl fieldKey={'termsAndConditions'} />}
    </>
  );
};

export default PaymentMethods;
